import { backgroundUtils, colors } from '#packages/util';
import { EditorRestrictionsApiKey } from '#packages/apis';
import experiment from 'experiment';
import * as stateManagement from '#packages/stateManagement';

import type { EditorAPI } from '#packages/editorAPI';
import type { MapStateToProps } from 'types/redux';
import type { SectionEmptyStateOwnProps } from './SectionEmptyState';

const PERCEIVED_LIGHTNESS_THRESHOLD = 0.5;
const isLightColor = (color: string) =>
  colors.getLumaPerceivedLightness(color) > PERCEIVED_LIGHTNESS_THRESHOLD;
const isCreateSectionWithAIEnabled = (editorAPI: EditorAPI) => {
  const isSchoolMode = stateManagement.schoolMode.selectors.isEnabled(
    editorAPI.store.getState(),
  );
  return experiment.isOpen('se_createSectionWithAI') && !isSchoolMode;
};

export interface SectionEmptyStateStateProps {
  isLightTextColor: boolean;
  isEmptyStateAddPanelVisible: boolean;
  isEmptyStateTitleTextVisible: boolean;
  shouldDisplayAISectionGeneratorButton: boolean;
}

export const mapStateToProps: MapStateToProps<
  SectionEmptyStateStateProps,
  SectionEmptyStateOwnProps
> = ({ editorAPI, dsRead }) => {
  const backgroundData = dsRead.pages.background.get(
    dsRead.pages.getCurrentPageId(),
    'desktop',
  );

  const pageBackgroundColor = backgroundUtils.getColorValue(
    editorAPI,
    backgroundData.ref.color,
  );

  const isLightTextColor = !isLightColor(pageBackgroundColor);

  const editorRestrictionsApi = editorAPI.host.getAPI(EditorRestrictionsApiKey);
  const isEmptyStateAddPanelVisible = editorRestrictionsApi.allowed(
    'sections_empty-state-add-panel.visible',
  );
  const isEmptyStateTitleTextVisible = editorRestrictionsApi.allowed(
    'sections_empty-state-title-text.visible',
  );
  return {
    isLightTextColor,
    shouldDisplayAISectionGeneratorButton:
      isCreateSectionWithAIEnabled(editorAPI),
    isEmptyStateAddPanelVisible,
    isEmptyStateTitleTextVisible,
  };
};
